<template>
    <UnitInfo__sensors_template
        v-for="output in outputs"
        :class="$attrs.class"
        :key="output.index"
        :unitId="unitId"
        :icon="output.icon"
        :title="output.title"
        :statusClass="output.statusClass"
        :statusIcon="output.statusIcon"
        :value="$t(output.value || '-')"
        :valueText="output.valueText"
    />
</template>

<script>
import UnitInfo__sensors_default from "@/components/units/sensors/UnitInfo__sensors_default.vue";
import UnitInfo__sensors_template from "@/components/units/sensors/UnitInfo__sensors_template.vue"

export default {
    name: "UnitInfo__sensors_outputs",
    extends: UnitInfo__sensors_default,
    inheritAttrs: false,
    components:{
        UnitInfo__sensors_template,
    },
    data() {
        return {
            optionsByValue:{
                'on': {
                    icon: 'output',
                    iconContainerClass: '',
                    value: 'On',
                    statusClass: '',
                    statusIcon: '',
                },
                'off':{
                    icon: 'output',
                    iconContainerClass: '',
                    value: 'Off',
                    statusClass: '',
                    statusIcon: '',
                },
                'null':{
                    icon: 'output',
                    iconContainerClass: '',
                    value: '-',
                    statusClass: '',
                    statusIcon: '',
                }
            }
        }
    },
    computed:{
        outputs() {
            return (this.unitOutputs || []).map((out, i) => {
                let options = this.optionsByValue[out.value];
                return {
                    index: i,
                    icon: this.showIcon ? options.icon : false,
                    iconContainerClass: options.iconContainerClass,
                    title: this.$te('output.types.' + out.name) ? this.$t('output.types.' + out.name) : out.name,
                    statusClass: options.statusClass,
                    statusIcon: options.statusIcon,
                    value: options.value,
                    valueText: '',//out.name,
                    view: out.view,
                }
            }).filter(inp => inp.view)
        },
    },
    watch: {
        value: {
            handler: function (val) {
                if(this.sensorsValues) {
                    let values = val.filter(v => v.value)
                    this.sensorsValues.outputs = values.length ? values : null
                }
            },
            immediate: true
        },
    },
}
</script>

<style scoped>

</style>